import { usePageContext } from '../../../../context.js';
import { wrapper } from './container.input.style.js';
import { Canvas } from './organism.canvas.js';
import { jsx } from 'react/jsx-runtime';

function InputContainer(props) {
  const pageContext = usePageContext();
  return /*#__PURE__*/jsx("div", {
    className: wrapper,
    "data-page-context": pageContext,
    children: /*#__PURE__*/jsx(Canvas, {
      ...props
    })
  });
}

export { InputContainer };
//# sourceMappingURL=container.input.js.map
